var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-form-group', {
    attrs: {
      "label": _vm.label,
      "label-for": "centro-custo-select"
    }
  }, [_c('VueSelect', {
    attrs: {
      "id": "centro-custo-select",
      "label": "nome",
      "value": _vm.selecionado,
      "options": _vm.opcoes,
      "filterable": false,
      "clearable": true,
      "loading": _vm.carregando || _vm.criando,
      "disabled": _vm.disabled || _vm.criando,
      "placeholder": _vm.allowCreate ? 'Pesquise ou cadastre um centro de custo' : 'Selecione um centro de custo'
    },
    on: {
      "open": _vm.carregar,
      "search": function search($event) {
        _vm.termoBusca = $event;
      },
      "input": _vm.selecionar
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [option.criarNovo ? _c('div', {
          staticClass: "centro-custo-create-option"
        }, [_c('Plus', {
          attrs: {
            "size": 17
          }
        }), _c('span', [_vm._v("Cadastrar “" + _vm._s(option.nome) + "”")])], 1) : _c('div', [_vm._v(_vm._s(option.nome))])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', [_vm._v(_vm._s(option.nome))])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" " + _vm._s(_vm.allowCreate ? "Digite o nome do centro de custo" : "Nenhum centro de custo encontrado") + " ")])], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };